// Supplier with 0-10 range of weddings shot is considered new
export const getIsNewSupplier = ([min, max]: number[]) => min === 0 && max === 10;
